import RegisterForm from 'components/service/RegisterForm';

const ServiceRegisterFormPage = () => {
  return <RegisterForm />;
};

export default ServiceRegisterFormPage;
